import React, { useEffect, useState } from 'react';
import { ColorRing, TailSpin } from 'react-loader-spinner'
import eventEmitter from './helpers/eventEmitter';

const Loader = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleLoadingStart = () => setLoading(true);
        const handleLoadingStop = () => { setLoading(false) }

        eventEmitter.on('showLoading', handleLoadingStart);
        eventEmitter.on('hideLoading', handleLoadingStop);

        return () => {
            eventEmitter.off('showLoading', handleLoadingStart);
            eventEmitter.off('hideLoading', handleLoadingStop);
        };
    }, [eventEmitter]);

    return (
        loading && <div className='loader-overlay'>
            <ColorRing
                visible={true}
                height="100"
                width="100"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={['#01B1E3', '#01B1E3', '#01B1E3', '#01B1E3', '#01B1E3']}
            />
        </div>
    )
}

export default Loader
